const placeHolder = 'https://static.introwise.com/images/placeholder-gradient.jpg';

const getEventPhotoUrl = (photo: string) => {
  return photo || placeHolder;
};

// eslint-disable-next-line import/prefer-default-export
export { getEventPhotoUrl };
